const getParams = async () => {
  const params = new URLSearchParams(window.location.search);
  const layout = params.get('layout') || 'BasicLayout';
  const platform = params.get('platform');
  const tenantId = params.get('tenantId');
  const productId = params.get('productId');
  const locale = params.get('locale') || 'en';
  const channelId = params.get('application') || params.get('channelId');
  const integrationType = params.get('integrationType');
  const productName = 'NumbersBetting';
  const tenantTimezone = params.get('tenantTimezone') || params.get('timeZone') || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const windowTitle = params.get('windowTitle') || params.get('appName');
  const environment = params.get('env') || params.get('environment');
  const systemsSdk = params.get('systemsSdk');
  const appRunUuid = params.get('appRunUuid');
  const customDomain = params.get('customDomain');
  const configData = {
    platform,
    environment,
    tenantId,
    productId,
    productName,
    locale,
    channelId,
    integrationType,
    tenantTimezone,
    windowTitle,
    customDomain,
  };
  return {
    configData,
    layout,
    windowTitle,
    environment,
    systemsSdk,
    appRunUuid,
  };
};

export default getParams;
